export const featuredPortfolio = [
  {
    id: 1,
    title: "吉Flix",
    img: "assets/imgs/netflix.webp",
    link: "https://notion-movie.onrender.com/"
  },
  {
    id: 2,
    title: "Catch Me if You Can",
    img: "assets/imgs/catch.webp",
    link: "https://catch-me-if-u-can.netlify.app/"
  },
  {
    id: 3,
    title: "Pokemon Game",
    img: "assets/imgs/pokemon.webp",
    link: "https://pokemon-rpg-game.netlify.app/"
  },
  {
    id: 4,
    title: "Portfolio Tracker",
    img: "assets/imgs/tracker.png",
    link: "https://g-portfolio-tracker.netlify.app"
  },
  {
    id: 5,
    title: "Portfolio",
    img: "assets/imgs/portfolio.png",
  },
];

export const webPortfolio = [
  {
    id: 1,
    title: "吉Flix",
    img: "assets/imgs/netflix.webp",
    link: "https://notion-movie.onrender.com/"
  },
  {
    id: 2,
    title: "Portfolio Tracker",
    img: "assets/imgs/tracker.png",
    link: "https://pokemon-rpg-game.netlify.app/"
  },
  {
    id: 3,
    title: "Portfolio",
    img: "assets/imgs/portfolio.png",
  },
];

export const gamePortfolio = [
  {
    id: 1,
    title: "Catch Me if You Can",
    img: "assets/imgs/catch.webp",
    link: "https://catch-me-if-u-can.netlify.app/"
  },
  {
    id: 2,
    title: "Pokemon Game",
    img: "assets/imgs/pokemon.webp",
    link: "https://pokemon-rpg-game.netlify.app/"
  },
];

export const projectPortfolio = [
  {
    id: 1,
    title: "To-do List",
    img: "assets/imgs/todo.png",
    link: "https://g-to-do.netlify.app/"
  },
  {
    id: 2,
    title: "Movie App",
    img: "assets/imgs/movie.webp",
    link: "https://g-movie-app.netlify.app/"
  },
  {
    id: 3,
    title: "Note App",
    img: "assets/imgs/note.png",
    link: "https://g-note-app.netlify.app"
  },
  {
    id: 4,
    title: "Pokedex",
    img: "assets/imgs/pokedex.png",
    link: "https://g-pokedex.netlify.app"
  },
  {
    id: 5,
    title: "Theme Clock",
    img: "assets/imgs/clock.webp",
    link: "https://g-theme-clock.netlify.app"
  },
  {
    id: 6,
    title: "Wake Up",
    img: "assets/imgs/wakeup.png",
    link: "https://g-wake-up.netlify.app/"
  },
  {
    id: 7,
    title: "Password Generator",
    img: "assets/imgs/generator.webp",
    link: "https://g-password-generator.netlify.app"
  },
  {
    id: 8,
    title: "Password Strength Observer",
    img: "assets/imgs/strength.png",
    link: "https://g-password-strength-observer.netlify.app"
  },
];